<script>
  import { HorizontalBar, mixins } from 'vue-chartjs';

  const { reactiveProp } = mixins;

  export default {
    extends: HorizontalBar,
    mixins: [reactiveProp],
    props: ['totalStudents'],
    data() {
      return {
        chartOptions: {
          scales: {
            xAxes: [{
              ticks: {
                maxTicksLimit: 4,
                min: 0,
                max: this.totalStudents,
              },
              gridLines: {
                display: true,
              },
            }],
            yAxes: [{
              barThickness: 20,
            }],
          },
          legend: {
            display: false,
          },
          tooltips: {
            callbacks: {
              title: tooltipItem => (
                /* eslint-disable dot-notation */
                `${tooltipItem[0]['xLabel']}${this.$t('common.modal.preview.count')}`
                /* eslint-enable */
              ),
              label: () => (''),
            },
            displayColors: false,
            backgroundColor: 'rgba(255,255,255,1)',
            borderColor: '#00c896',
            borderWidth: 1,
            titleFontColor: '#000000',
            titleFontStyle: 'normal',
          },
        },
      };
    },
    mounted() {
      this.renderChart(this.chartData, this.chartOptions);
    },
  };
</script>



// WEBPACK FOOTER //
// src/app/classes/components/BarChart.vue